export default __webpack_public_path__ + "static/media/moments.544fa519.png";